import { faBars } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import {
  BrowserRouter as Router,
  Outlet,
  Route,
  Routes,
  useNavigate
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./assets/global.css";
import { Cbreadcrumb } from "./features/authentication/signUp";
import CFooter from "./layouts/footer/footer";
import CNavBar from "./layouts/Navbar";
import CSideBar from "./layouts/Sidebar";
import AboutUs from "./pages/AboutUs";
import RejectReason from "./pages/ArticleRejectReason";
import ContactUs from "./pages/Contactus";
import ContactUsFooter from "./pages/ContactUsFooter";
import ForgotPassword from "./pages/forgotPassword";
import ForgotPwdVerify from "./pages/forgotPwdOtp";
import Home from "./pages/Home";
import Login from "./pages/Login";
import MyPortal from "./pages/MyPortal";
import DashboardNewOrders from "./pages/NewOrder";
import OtpVerification from "./pages/OTP";
import DashboardPreviousOrders from "./pages/PreviousOrders";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Settings from "./pages/Settings";
import Registration from "./pages/Signup";
import TermsConditions from "./pages/TermsConditions";
import ThankyouPage from "./pages/Thankyou";
import ProductedRouter from "./productedRouter";

function DashboardLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const sidebarToggle = document.body.querySelector("#sidebarToggle");
    if (sidebarToggle) {
      if (localStorage.getItem("sb|sidebar-toggle") === "true") {
        document.body.classList.toggle("sidenav-toggled");
      }
      sidebarToggle.addEventListener("click", (event) => {
        event.preventDefault();
        document.body.classList.toggle("sidenav-toggled");
        localStorage.setItem(
          "sb|sidebar-toggle",
          document.body.classList.contains("sidenav-toggled")
        );
      });
    }
  }, []);

  const setLogout = () => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/logout`,
        {},
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        console.clear();
        sessionStorage.clear();
        navigate("/login");
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <CNavBar
        isButton={true}
        isbrandText={true}
        brandText={"Reachello"}
        brandPath={"/dashboard"}
        brandTextStyle={{ color: "#044389", fontWeight: "bold" }}
        navBgColor={"white"}
        menuAlignment={"right"}
        btnClassDiv={"col-sm-4 mb-sm-2 mt-sm-2"}
        buttonListArray={["Logout"]}
        setAction={() => setLogout()}
        btnCustomStyle={{
          border: "1px solid black",
          backgroundColor: "white",
          color: "#044389",
        }}
        btnClasses={"px-4 me-3"}
        btnFontWeight={"bold"}
        spaceBetweenItems={5}
        faIcon={faBars}
        faClass={"fa-xl"}
        faStyle={{color: "#044389"}}
        faTitle={"Sidebar"}
      />
      <div id="layoutSidenav">
        <CSideBar />
        <div id="layoutSidenav_content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
      <CFooter
        copyRightBlockAlignment={"right"}
        copyRightTextAlignment={"right"}
      />
    </>
  );
}

function App(props) {
  const [isLogged, setIsLogged] = useState(false);

  return (
    <>
      <Router>
        <Routes>
          {/* signup */}
          <Route path="/">
            <Route
              path=""
              element={<Home setRegStatus={(status) => setIsLogged(status)} />}
            />
            {/* <Route element={<ProductedRouter isLoggedIn={isLogged} />}> */}
            <Route
              path="otp"
              element={
                <OtpVerification
                  setOtpStatus={(status) => setIsLogged(status)}
                />
              }
            />
            {/* </Route> */}

            {/* registration */}
            {/* <Route element={<ProductedRouter isLoggedIn={isLogged} />}> */}
            <Route path="registration">
              <Route path="" element={<Registration />}></Route>
              <Route path=":portal_id" element={<Registration />}></Route>
            </Route>
            {/* </Route> */}
            <Route path="registration/congratz" element={<ThankyouPage />} />

            {/* login */}
            <Route path="login">
              <Route
                path=""
                element={
                  <Login setLoginStatus={(status) => setIsLogged(status)} />
                }
              />
              <Route
                path="otp"
                element={
                  <ForgotPwdVerify
                    setOtpStatus={(status) => setIsLogged(status)}
                  />
                }
              />
              {/* <Route element={<ProductedRouter isLoggedIn={isLogged} />}> */}
              <Route path="forgot-password" element={<ForgotPassword />} />
              {/* </Route> */}
            </Route>
          </Route>

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/contact-us" element={<ContactUsFooter />} />
          <Route path="/about-us" element={<AboutUs />} />


          {/* dashboard */}

          <Route element={<ProductedRouter isLoggedIn={isLogged} />}>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route path="" element={<MyPortal />}></Route>
              <Route path="new-orders" element={<DashboardNewOrders />}></Route>
              <Route
                path="previous-orders"
                element={<DashboardPreviousOrders />}
              ></Route>
              <Route path="payments" element={<h1>Payments</h1>}></Route>
              <Route path="contact-us" element={<ContactUs />}></Route>
              <Route path="settings" element={<Settings />}></Route>
              <Route path="add-new-business">
                <Route
                  path=""
                  element={<Cbreadcrumb page={"add-new-business"} />}
                ></Route>
                <Route
                  path=":portal_id"
                  element={<Cbreadcrumb page={"update-new-business"} />}
                ></Route>
              </Route>

              <Route path="rejected/:order_id" element={<RejectReason />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
